import { ISessionTokenResponseSchema } from '@cian/chats-api/lib/browser-entry';

import { fetchUsersSession as _fetchUsersSession, TUsersSessionResponse } from '../repositories/chats/v1/users-session';
import { IApplicationContext } from '../types/applicationContext';

type TFetchUsersSessionParams = {
  cookies?: string;
  timezone?: number;
};

function isSessionToken(obj: {}): obj is ISessionTokenResponseSchema {
  return obj && 'expiration' in obj && 'sessionToken' in obj && 'userId' in obj;
}

export async function fetchUsersSession(
  { httpApi, logger, custom }: IApplicationContext,
  { cookies, timezone }: TFetchUsersSessionParams,
) {
  try {
    const { statusCode, response }: TUsersSessionResponse = await _fetchUsersSession({
      httpApi,
      parameters: { timezone },
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode >= 400) {
      // Пользователь не авторизован
      return null;
    }

    if (!isSessionToken(response)) {
      logger.warning('Невалидный ответ от сервера', {
        message: 'Не удалось получить токен сессии',
        domain: 'src/shared/services/fetchUsersSession.ts',
        ...(response || { errors: ['Отсутствует тело ответа'] }),
        ...custom,
      });

      return null;
    }

    return response;
  } catch (error) {
    logger.error(error, {
      message: 'Не удалось получить токен сессии',
      domain: 'src/shared/services/fetchUsersSession.ts',
      ...custom,
    });

    return null;
  }
}
